import createGibberishDetector from 'gibberish-detective';

const gibberishDetector = createGibberishDetector({ useCache: true });
const INTERNAL_SEGMENT_WORD_COUNT = 5;

const containsGibberishSegment = (text: string): boolean => {
  const words = text.split(/\s+/);

  if (words.length <= INTERNAL_SEGMENT_WORD_COUNT) {
    return false;
  }

  for (let index = 0; index <= words.length - INTERNAL_SEGMENT_WORD_COUNT; index++) {
    const segment = words.slice(index, index + INTERNAL_SEGMENT_WORD_COUNT).join(' ');

    if (gibberishDetector.detect(segment)) {
      return true;
    }
  }

  return false;
};

export const isGibberishText = (text?: string): boolean => {
  const normalizedText = text?.trim();

  if (!normalizedText) {
    return false;
  }

  return gibberishDetector.detect(normalizedText) || containsGibberishSegment(normalizedText);
};
